<div class="launch-bar" [@launchBarAnimation] [ngStyle]="{ top: topPos, right: rightPos }">
    <uvx-icon-button
        *ngFor="let item of launchServices"
        [icon]="item.icon"
        [matTooltip]="item.tooltip"
        [routerLink]="item.link"
    ></uvx-icon-button>
    <uvx-icon-button icon="error" matTooltip="Launch Service 4"></uvx-icon-button>
</div>
